import axiosTokenInstance from 'services/api/backoffice';
import { STRIPE, STRIPE_ERROR } from '_models/redux/types';

// Action function
export const stripeAction =
  (page, size, filters = {}) =>
  async (dispatch) => {
    // Endpoint: Try & Catch
    try {
      const params = { page, size, ...filters };
      const response = await axiosTokenInstance.get(`api/reports/v2/transactions-stripe`, {
        params,
      });

      const { data, status } = response || {};

      console.log('response stripe', response);

      dispatch({
        type: STRIPE,
        payload: data || {},
        status: status || {},
        method: 'get',
      });
    } catch (e) {
      dispatch({
        type: STRIPE_ERROR,
        payload: e || {},
      });
    }
  };
